import { Injectable } from '@angular/core';

import type { CustomerGuest } from 'src/models/customer-guest.model';

export type MessagesHandoff =
  | { type: 'guest'; guest: CustomerGuest }
  | { type: 'room'; chatRoomKey: string; details: { pageTitle?: string; chatRoom?: any } | null };

// Desktop keeps the Messages page alive between visits, so it comes back
// painted with the last conversation. Ionic Storage is async (IndexedDB), and
// reading a handoff from it leaves that conversation on screen for a few
// hundred ms. Held in memory, Messages can switch before the first paint.
@Injectable({ providedIn: 'root' })
export class MessagesHandoffService {
  private pending: MessagesHandoff | null = null;

  set(handoff: MessagesHandoff): void {
    this.pending = handoff;
  }

  take(): MessagesHandoff | null {
    const handoff = this.pending;
    this.pending = null;
    return handoff;
  }
}
